class HotspotBanner extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback () {
    this.initializeElements()
    this.setupEventListeners()
  }

  initializeElements () {
    this.elements = {
      desktopTriggers: this.querySelectorAll('[data-block-trigger-desktop]'),
      mobileTriggers: this.querySelectorAll('[data-block-trigger-mobile]'),
      targets: this.querySelectorAll('[data-block-target]'),
      descriptions: this.querySelectorAll('[data-element-description]'),
      defaultDescription: this.querySelector('[data-element-description-default]'),
      closeButtons: this.querySelectorAll('[data-element-close]'),
      quickAddButtons: this.querySelectorAll('[data-quick-add]')
    }
  }

  setupEventListeners () {
    this.elements.desktopTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        const target = this.findTarget(trigger)

        if (!target) return
        this.showContent(target)
      })

      trigger.addEventListener('mouseout', () => {
        const target = this.elements.defaultDescription

        if (!target) return
        this.showContent(target)
      })
    })

    this.elements.mobileTriggers.forEach((trigger) => {
      trigger.addEventListener('touchstart', () => {
        const target = this.findTarget(trigger)

        if (!target) return
        this.showContent(target)
      })
    })

    this.elements.closeButtons.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const target = this.findTarget(trigger)

        if (!target) return

        this.hideContent(target)
        this.showDefaultContent()
      })
    })

    this.elements.quickAddButtons.forEach((el) => {
      el.addEventListener('touchstart', () => {
        console.log('open quick add')
      })
    })
  }

  findTarget (trigger) {
    return [...this.elements.targets].find((el) =>
      el.dataset.blockId === trigger.dataset.blockId
    )
  }

  showDefaultContent () {
    const defaultDescription = this.elements.defaultDescription
    if (!defaultDescription) return

    this.showContent(defaultDescription)
  }

  showContent (el) {
    this.hideAll()
    el.removeAttribute('aria-hidden')
  }

  hideAll () {
    this.elements.descriptions.forEach((el) => {
      this.hideContent(el)
    })
  }

  hideContent (el) {
    el.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('hotspot-banner')) {
  customElements.define('hotspot-banner', HotspotBanner)
}
